var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 8.9 11.5"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 8.9 11.5","xml:space":"preserve"}},[_c('polygon',{staticClass:"st0",attrs:{"points":"0,0 0,11.5 8.9,5.7 "}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }